module.exports = __webpack_public_path__ + "static/chr-logo-dark-40c4ad6c54ec1ae6c6f877ca57022ecb.svg";